export function collectorFullName(person) {
  const fullname = person?.name;

  if (person?.legacyId) {
    return `${person.legacyId} - ${fullname}`;
  }
  return fullname;
}
